module.exports = __webpack_public_path__ + "img/9手机.44dbbeec.png";